import {
  GET_COURSE_ENROLLMENT_RECORDS_ERROR,
  GET_COURSE_ENROLLMENT_RECORDS_SUCCESS,
  GET_EVALUATION_RECORDS_ERROR,
  GET_EVALUATION_RECORDS_SUCCESS,
  GET_MARKETING_RECORDS_ERROR,
  GET_MARKETING_RECORDS_SUCCESS,
  GET_SEMI_ANNUAL_REPORT_RECORDS_ERROR,
  GET_SEMI_ANNUAL_REPORT_RECORDS_SUCCESS,
  GET_FILTER_RECORDS_SUCCESS,
  GET_FILTER_RECORDS_ERROR,
  GET_COURSEFACILATION_REPORT_SUCCESS,
  RESET_COURSE_FACILATION_DATA,
  RESET_MARKETING_RECORDS_DATA,
  RESET_EVALUATION_RECORDS,
} from "../constants";

export const initialState = {
  marketingReports: undefined,
  courseEnrollmentNumbers: undefined,
  evaluationReports: undefined,
  semiAnnualReports: [],
  filterReports: [],
  courseFacilationReport: undefined,
};
export const ReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MARKETING_RECORDS_SUCCESS:
      return {
        ...state,
        marketingReports: action.payload,
      };
    case RESET_MARKETING_RECORDS_DATA: {
      return {
        ...state,
        marketingReports: undefined,
      };
    }
    case GET_COURSEFACILATION_REPORT_SUCCESS: {
      return {
        ...state,
        courseFacilationReport: action.payload,
      };
    }

    case RESET_COURSE_FACILATION_DATA: {
      return {
        ...state,
        courseFacilationReport: undefined,
      };
    }
    case GET_MARKETING_RECORDS_ERROR:
      return {
        ...state,
        marketingReports: undefined,
      };
    case GET_COURSE_ENROLLMENT_RECORDS_SUCCESS:
      return {
        ...state,
        courseEnrollmentNumbers: action.payload,
      };
    case GET_COURSE_ENROLLMENT_RECORDS_ERROR:
      return {
        ...state,
        courseEnrollmentNumbers: undefined,
      };
    case GET_EVALUATION_RECORDS_SUCCESS:
      return {
        ...state,
        evaluationReports: action.payload,
      };
    case RESET_EVALUATION_RECORDS: {
      return {
        ...state,
        evaluationReports: undefined,
      };
    }
    case GET_EVALUATION_RECORDS_ERROR:
      return {
        ...state,
        evaluationReports: undefined,
      };
    case GET_SEMI_ANNUAL_REPORT_RECORDS_SUCCESS:
      return {
        ...state,
        semiAnnualReports: action.payload,
      };
    case GET_SEMI_ANNUAL_REPORT_RECORDS_ERROR:
      return {
        ...state,
        semiAnnualReports: [],
      };
    case GET_FILTER_RECORDS_SUCCESS:
      return {
        ...state,
        filterReports: action.payload,
      };
    case GET_FILTER_RECORDS_ERROR:
      return {
        ...state,
        filterReports: [],
      };

    default:
      return state;
  }
};
